import { render, staticRenderFns } from "./reviewList.vue?vue&type=template&id=8523fd4c&scoped=true"
import script from "./reviewList.vue?vue&type=script&lang=js"
export * from "./reviewList.vue?vue&type=script&lang=js"
import style0 from "./reviewList.vue?vue&type=style&index=0&id=8523fd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8523fd4c",
  null
  
)

export default component.exports